import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
//Mui components
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Create';
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';
import BellIcon from '@mui/icons-material/Notifications';
import LinkIcon from '@mui/icons-material/Link';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
//Styles
import useStyles from 'components/tables/ControlTowerTable/ControlTowerTable.style';
// Facade
import Facade from 'core/Facade';
// PCP Components
import DialogEditUrl from 'components/dialogs/controlTower/DialogEditUrl';
import DialogEditPrice from 'components/dialogs/controlTower/DialogEditPrice';
import DialogLogs from 'components/dialogs/controlTower/DialogLogs';
import DialogUrlParams from 'components/dialogs/controlTower/DialogUrlParams';
import DialogData from 'components/dialogs/controlTower/DialogData';
import stockIcon from 'assets/svg/stockIcon';
// Theme
import theme from 'assets/theme/theme.js';
import { useEffect } from 'react';
import { Tooltip } from '@mui/material';

const ControlTowerRow = ({
    changeAction,
    displayDoneRow,
    siteId,
    item
}) => {

    const classes = useStyles();
    const [urlParams, setUrlParams] = useState({});

    const [dialogPriceOpen, setDialogPriceOpen] = useState(false);
    const [dialogUrlOpen, setDialogUrlOpen] = useState(false);
    const [dialogLogsOpen, setDialogLogsOpen] = useState(false);
    const [dialogUrlParamsOpen, setDialogUrlParamsOpen] = useState(false);

    const [currentItem, setCurrentItem] = useState(null);

    const [openDialogData, setOpenDialogData] = useState(false);

    const { associatedItems, id, logs, retrievedData, url } = item;

    useEffect(() => {
        setUrlParams(getUrlParams());
    }, [url]);

    const closeDialog = () => {
        setDialogPriceOpen(false);
        setDialogUrlOpen(false);
        setDialogLogsOpen(false);
        setDialogUrlParamsOpen(false);
    };

    const getUrlParams = () => {
        const config = Facade.getConfig(url);
        const reference = Facade.getRef(url);
        const add = Facade.getAdd(url);
        const mul = Facade.getMul(url);
        const isNoConfig = config.length === 0 && !reference;

        return {
            config,
            reference,
            add,
            mul,
            isNoConfig
        };
    };

    const stockColor = (stockLabel) => {
        const stock = stockLabel.replace(/\W_/g, '').toLowerCase();

        let color = theme.palette.grey.main;

        switch (stock) {
        case 'en stock':
            color = theme.palette.green.stock;
            break;
        case 'rupture':
            color = theme.palette.black.main;
            break;
        case 'sup. 48h' || '+5 jours':
            color = theme.palette.red.light;
            break;
        default:
            return theme.palette.grey.main;
        }

        return color;
    };

    const handleClickIcon = (action, associatedItemId, accountId, params) => {

        const ids = [{
            article_id: associatedItemId,
            account_id: accountId,
            item_id: item.id
        }];
        const newParams = params ? params : {};

        changeAction(action, ids, siteId, false, newParams);
    };

    const renderDialogEditUrl = () => <DialogEditUrl
        close={closeDialog}
        open={dialogUrlOpen}
        url={url}
        changeAction={(params) => handleClickIcon('SET_URL', currentItem.articleId, currentItem.accountId, params)} />;

    const renderDialogEditPrice = () => <DialogEditPrice
        key={currentItem ? currentItem.id : ''}
        close={closeDialog}
        open={dialogPriceOpen}
        beforeData={currentItem ? currentItem.previousData : {}}
        botData={retrievedData}
        nowData={currentItem ? currentItem.currentData : {}}
        price={associatedItems[0] ? associatedItems[0].currentData.originalPrice ? associatedItems[0].currentData.originalPrice : associatedItems[0].currentData.price : null}
        stock={associatedItems[0] ? associatedItems[0].currentData.stock : 'no information'}
        changeAction={(params) => handleClickIcon('SET_VALUE', currentItem.articleId, currentItem.accountId, params)} />;

    const renderDialogLogs = () =>
        <DialogLogs
            close={closeDialog}
            open={dialogLogsOpen}
            logs={logs} />;

    const renderDialogUrlParams = () =>
        <DialogUrlParams
            close={closeDialog}
            open={dialogUrlParamsOpen && !urlParams.isNoConfig}
            params={{ config: urlParams.config, reference: urlParams.reference }} />;

    const renderDialogData = () => <DialogData
        open={openDialogData}
        onClose={() => setOpenDialogData(false)}
        editMode={false}
        name={currentItem ? currentItem.articleName : ''}
        url={url}
        closeNoSaving={() => setOpenDialogData(false)}
        beforeData={currentItem ? currentItem.previousData : {}}
        botData={retrievedData}
        nowData={currentItem ? currentItem.currentData : {}}/>;

    if (associatedItems.length === 0)
        return null;

    if (!displayDoneRow && !associatedItems.find(i => i.supervisorAction === '' || i.supervisorAction === 'NONE'))
        return null;

    return (
        <TableRow key={id}>
            <TableCell component='th' scope='row' className={classes.productNameCell}>
                <div className={classes.productNameCellContent} style={{ height: associatedItems.length > 1 ? '90px' : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ marginTop: key > 0 && '5px' }}>
                            <div key={key} className={classes.productName} title={associatedItem.articleName}>{associatedItem.articleName}</div>
                            <div style={{ display: 'flex' }}>
                                <div className={classes.url} id='controlTowerUrl' onClick={() => item.redirection ? Facade.openUrl(item.redirection):Facade.openUrl(url)}>{url}</div>
                            </div>
                        </div>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? `${associatedItems.length * 43}px` : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ marginTop: key > 0 && '5px' }}>{associatedItem.accountName}</div>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.iconCell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? `${associatedItems.length * 43}px` : undefined }}>
                    {associatedItems.map((_, key) =>
                        <InfoIcon key={key} style={{ marginTop: key > 0 && '5px' }} className={classes.icon} onClick={() => setDialogLogsOpen(true)} />
                    )}
                    {renderDialogLogs()}
                </div>
            </TableCell>
            <TableCell className={classes.iconCell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? `${associatedItems.length * 43}px` : undefined }}>
                    {associatedItems.map((_, key) =>
                        <SettingsIcon key={key} className={classes.paramsIcon} style={{ color: urlParams.isNoConfig ? 'grey': theme.palette.orange.main, marginTop: key > 0 && '5px' }} onClick={() => urlParams.isNoConfig ? null : setDialogUrlParamsOpen(true)} />
                    )}
                    {renderDialogUrlParams(urlParams)}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent} >
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ marginTop: key > 0 && '5px' }}>
                            <div
                                className={ClassNames(classes.priceCellContent, associatedItem.supervisorAction === 'VALIDATE_BEFORE'? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                                onClick={() => handleClickIcon('VALIDATE_BEFORE', associatedItem.articleId, associatedItem.accountId)}
                            >
                                <div className={classes.price}>
                                    {associatedItem.previousData.originalPrice ? associatedItem.previousData.originalPrice : associatedItem.previousData.price}
                                </div>
                                {stockIcon(20,20,stockColor(associatedItem.previousData.stock))}
                            </div>
                        </div>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent}>
                    {associatedItems.map((associatedItem, key) =>
                        retrievedData ?
                            <div
                                key={key}
                                style={{ marginTop: key > 0 && '5px' }}
                                className={ClassNames(classes.priceCellContent, associatedItem.supervisorAction === 'VALIDATE_BOT'? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                                onClick={() => handleClickIcon('VALIDATE_BOT', associatedItem.articleId, associatedItem.accountId)}>
                                <div className={classes.price}>
                                    {retrievedData.marketplaceOffers[0]?
                                        retrievedData.marketplaceOffers[0].original_price ?
                                            retrievedData.marketplaceOffers[0].original_price : retrievedData.marketplaceOffers[0].price
                                        : retrievedData.originalPrice ? retrievedData.originalPrice : retrievedData.price
                                    }
                                </div>
                                {retrievedData.marketplaceOffers[0] ?
                                    <div className={ classes.marketPlaceStock}>
                                        {stockIcon(20,20,stockColor(retrievedData.stock))}
                                        {retrievedData.marketplaceOffers[0].original_shipping_cost ? retrievedData.marketplaceOffers[0].original_shipping_cost : retrievedData.marketplaceOffers[0].shipping_cost}
                                    </div>
                                    :
                                    stockIcon(20,20,stockColor(retrievedData.stock))
                                }
                            </div>
                            : '-'
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? `${associatedItems.length * 43}px` : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ marginTop: key > 0 && '5px' }}>{retrievedData && associatedItem.previousData.price > 0 && retrievedData.price > 0 && associatedItem.previousData.price > 0 ? (((retrievedData.price - associatedItem.previousData.price) / associatedItem.previousData.price) * 100).toFixed(2) + ' %' : '-'}</div>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent} >
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ display: 'flex', marginTop: key > 0 && '5px' }}>
                            <div
                                className={ClassNames(classes.priceCellContent, associatedItem.supervisorAction === 'VALIDATE_NOW' || associatedItem.supervisorAction === 'SET_VALUE'? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                                onClick={() => handleClickIcon('VALIDATE_NOW', associatedItem.articleId, associatedItem.accountId)}>
                                <div className={classes.price}>
                                    {associatedItem.currentData.originalPrice ? associatedItem.currentData.originalPrice : associatedItem.currentData.price}
                                </div>
                                {stockIcon(20,20,stockColor(associatedItem.currentData.stock))}
                            </div>
                            <IconButton
                                size='small'
                                style={{ width: '40px' }}
                                onClick={() => {
                                    setDialogPriceOpen(true);
                                    setCurrentItem(associatedItem);
                                }}>
                                <EditIcon />
                            </IconButton>
                        </div>
                    )}
                    {renderDialogEditPrice()}
                </div>
            </TableCell>
            <TableCell className={classes.cell}>
                <div className={classes.cellContent} >
                    {associatedItems.map((associatedItem, key) =>
                        <div key={key} style={{ marginTop: key > 0 && '5px', display: 'flex' }}>
                            <div className={classes.priceCellContent}>
                                <div className={classes.price}>
                                    {associatedItem.currentData.price}
                                </div>
                                {stockIcon(20,20,stockColor(associatedItem.currentData.stock))}
                            </div>
                            {(urlParams.mul || urlParams.add) && <Tooltip
                                title={urlParams.add ? `bw_add = ${urlParams.add } \n`: `bw_mul = ${urlParams.mul }` + (urlParams.add && urlParams.mul) && `bw_mul = ${urlParams.mul }`}
                                placement='top'
                                arrow>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-around' }}>
                                    <AddIcon style={{ height: '15px', color: urlParams.add ? '#0276aa' : 'grey' }} />
                                    <CloseIcon style={{ height: '15px', color: urlParams.mul ? '#ff9800' : 'grey' }} />
                                </div>
                            </Tooltip>}
                        </div>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.iconCell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? '90px' : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <IconButton key={key} style={{ marginTop: key > 0 && '5px' }} onClick={() => handleClickIcon('SET_NV_BELL', associatedItem.articleId, associatedItem.accountId)}>
                            <BellIcon className={ClassNames(classes.icon, associatedItem.supervisorAction === 'SET_NV_BELL' && classes.nvBellIcon)}/>
                        </IconButton>
                    )}
                </div>
            </TableCell>
            <TableCell className={classes.iconCell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? '90px' : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <IconButton key={key}
                            style={{ marginTop: key > 0 && '5px' }}
                            onClick={() => {
                                setDialogUrlOpen(true);
                                setCurrentItem(associatedItem);
                            }}>
                            <LinkIcon className={associatedItem.supervisorAction === 'SET_URL' ? classes.urlIcon : classes.icon} />
                        </IconButton>
                    )}
                    {renderDialogEditUrl()}
                </div>
            </TableCell>
            <TableCell className={classes.iconCell}>
                <div className={classes.cellContent} style={{ height: associatedItems.length > 1 ? '90px' : undefined }}>
                    {associatedItems.map((associatedItem, key) =>
                        <IconButton
                            key={key}
                            style={{ marginTop: key > 0 && '5px' }}
                            onClick={() => {
                                setCurrentItem(associatedItem);
                                setOpenDialogData(true);
                            }}>
                            <SearchIcon className={classes.icon} />
                        </IconButton>
                    )}
                    {renderDialogData()}
                </div>
            </TableCell>
        </TableRow>
    );
};

ControlTowerRow.propTypes = {
    associatedItems: PropTypes.array,
    changeAction: PropTypes.func,
    displayDoneRow: PropTypes.bool,
    item: PropTypes.object,
    itemId: PropTypes.string,
    logs: PropTypes.array,
    name: PropTypes.string,
    retrievedData: PropTypes.object,
    siteId: PropTypes.string,
    url: PropTypes.string
};

export default ControlTowerRow;
